import React, { useState, useEffect } from "react";
import { Input, Radio, Badge, Divider } from "antd";
import { useSelector } from "react-redux";
import {
  SearchOutlined,
  DoubleLeftOutlined,
  DoubleRightOutlined,
  SwapOutlined,
} from "@ant-design/icons";
import ReservationListCards from "./ReservationListCards";
import EditReservationNewModal from "./ReservationTablesSubComponents/EditReservationNewModal";

const ReservationsList = ({ date }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [reservationStatus, setReservationStatus] = useState("Предстоящи");
  // const [timeRemaining, setTimeRemaining] = useState({});
  const [showFullTitle, setShowFullTitle] = useState();

  const { reservations } = useSelector(
    (state) => state.restaurantReservationsReducer
  );

  const { regions } = useSelector((state) => state.restaurantSchemaReducer);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const filteredReservations = reservations.filter((reservation) => {
    const matchesSearchQuery =
      reservation.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      reservation.phone.toLowerCase().includes(searchQuery.toLowerCase());

    if (reservationStatus === "Предстоящи") {
      return matchesSearchQuery && reservation.status === 1;
    } else if (reservationStatus === "Настанени") {
      return matchesSearchQuery && reservation.status === 2;
      // } else if (reservationStatus === "Минали") {
    } else {
      return matchesSearchQuery && reservation.status === 3;
    }
  });

  const sortReservationsByTime = (list) =>
    [...list].sort((a, b) =>
      a.reservationTime.localeCompare(b.reservationTime)
    );

  const regionLabels = regions.reduce((acc, region) => {
    acc[region.key] = region.label;
    return acc;
  }, {});

  const groupedReservations = regions
    .map((region) => ({
      regionId: region.key,
      regionName: region.label,
      reservations: sortReservationsByTime(
        filteredReservations.filter(
          (reservation) => reservation.regionId === region.key
        )
      ),
    }))
    .filter((group) => group.reservations.length > 0);

  const unassignedReservations = filteredReservations.filter(
    (reservation) => !regionLabels[reservation.regionId]
  );

  if (unassignedReservations.length > 0) {
    groupedReservations.push({
      regionId: "unknown",
      regionName: "Без регион",
      reservations: sortReservationsByTime(unassignedReservations),
    });
  }

  const futureReservationCount = reservations.filter((reservation) => {
    return reservation.status === 1;
  }).length;

  const seatedReservationCount = reservations.filter((reservation) => {
    return reservation.status === 2;
  }).length;

  const pastReservationCount = reservations.filter((reservation) => {
    return reservation.status === 3;
  }).length;

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768 && window.innerWidth < 1150) {
        setShowFullTitle("hide");
      } else {
        setShowFullTitle("show");
      }
    };

    // Initial check
    handleResize();

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <EditReservationNewModal date={date} />

      <Radio.Group
        className="reservations-list-card-filter"
        value={reservationStatus}
        onChange={(e) => setReservationStatus(e.target.value)}
      >
        <Badge
          style={{ zIndex: "2" }}
          color="blue"
          count={futureReservationCount}
        >
          <Radio.Button
            value="Предстоящи"
            style={{
              borderRadius: "10px 0px 0px 10px",
            }}
          >
            {showFullTitle === "show" ? "Предстоящи" : <DoubleLeftOutlined />}
          </Radio.Button>
        </Badge>
        <Badge color="blue" count={seatedReservationCount}>
          <Radio.Button
            value="Настанени"
            style={{
              borderRadius: "0px 0px 0px 0px",
            }}
          >
            {showFullTitle === "show" ? "Настанени" : <SwapOutlined />}
          </Radio.Button>
        </Badge>
        <Badge color="blue" count={pastReservationCount}>
          <Radio.Button
            value="Минали"
            style={{
              borderRadius: "0px 10px 10px 0px",
            }}
          >
            {showFullTitle === "show" ? "Минали" : <DoubleRightOutlined />}
          </Radio.Button>
        </Badge>
      </Radio.Group>

      <Input
        placeholder="Търсене..."
        prefix={<SearchOutlined />}
        value={searchQuery}
        onChange={handleSearchChange}
      />
      {groupedReservations.length === 0 ? (
        <div className="reservations-list-empty">Няма резервации</div>
      ) : (
        groupedReservations.map((group) => (
          <div className="reservations-list-group" key={group.regionId}>
            <Divider orientation="left" className="reservations-list-divider">
              {group.regionName}
            </Divider>
            <ReservationListCards data={group.reservations} />
          </div>
        ))
      )}
    </>
  );
};
export default ReservationsList;
